import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { IUserInfo } from '../../../types/Auth/authInterface';
import { useGetAppsMutation } from '../../../services/systemPermissions/systemPermissionsService';
import { SideBarSwitchWithLabel } from '../../../components/commons/SideBarComponents/SwitchWithLabel/sideBarSwitchWithLabel';
import {
  useAuthorizeApplicationMutation,
  useDeleteAuthorizedAppMutation
} from '../../../services/users/usersService';

interface ManageAuthorizedAppsSideBarProps {
  setOpenSideBar: (open: boolean) => void;
  user: IUserInfo;
  reloadTable: () => void;
}
export const ManageAuthorizedAppsSideBar = ({
  setOpenSideBar,
  user,
  reloadTable
}: ManageAuthorizedAppsSideBarProps) => {
  const [getAllApps, { isSuccess, isError, data }] = useGetAppsMutation();

  const [currentAuthorizedApps, setCurrentAuthorizedApps] = React.useState<
    {
      name: string;
      id: number;
      checked: boolean;
    }[]
  >([]);

  const [
    authorizeApp,
    { isSuccess: isSuccessAuthorizeApp, isError: isErrorAuthorizeApp }
  ] = useAuthorizeApplicationMutation();
  const [
    deleteAuthorizedApp,
    {
      isSuccess: isSuccessDeleteAuthorizedApp,
      isError: isErrorDeleteAuthorizedApp
    }
  ] = useDeleteAuthorizedAppMutation();

  const toastMessages = {
    authorize: {
      success: Strings.users.successAuthorizeApp,
      error: Strings.users.errorAuthorizeApp
    },
    delete: {
      success: Strings.users.successDeleteAuthorizedApp,
      error: Strings.users.errorDeleteAuthorizedApp
    }
  };

  useEffect(() => {
    getAllApps();
  }, []);

  useEffect(() => {
    if (isSuccess && Array.isArray(data) && data.length > 0) {
      setCurrentAuthorizedApps(
        data.map((app) => ({
          name: app.name,
          id: app.id,
          checked: user?.authorizedApps?.some(
            (userApp) => userApp.name === app.name
          )
        }))
      );
    }
  }, [isSuccess, data, user]);

  const userMadeChanges = currentAuthorizedApps.some(
    (app) =>
      app.checked !==
      user?.authorizedApps?.some((userApp) => userApp.name === app.name)
  );

  const handleChange = (currentApp: {
    name: string;
    id: number;
    checked: boolean;
  }) => {
    console.log('currentApp', currentApp);
    setCurrentAuthorizedApps(
      currentAuthorizedApps.map((app) =>
        app.id === currentApp.id
          ? { ...app, checked: !currentApp.checked }
          : { ...app }
      )
    );
  };

  const handleSave = () => {
    console.log('currentAuthorizedApps', currentAuthorizedApps);
    const authorizedApps = currentAuthorizedApps.filter((app) => app.checked);
    const newAuthorizedApps = authorizedApps.filter(
      (app) =>
        !user?.authorizedApps?.some((userApp) => userApp.name === app.name)
    );
    const deletedApps = user?.authorizedApps?.filter(
      (userApp) => !authorizedApps.some((app) => app.name === userApp.name)
    );
    console.log('newAuthorizedApps', newAuthorizedApps, user.id);
    console.log('deletedApps', deletedApps);

    newAuthorizedApps.forEach((app) => {
      authorizeApp({
        userId: user.userId,
        appId: app.id
      });
    });

    deletedApps.forEach((app) => {
      deleteAuthorizedApp(app.id);
    });
  };

  useEffect(() => {
    if (isSuccessAuthorizeApp) {
      toast.success(toastMessages.authorize.success);
      setOpenSideBar(false);
      reloadTable();
    } else if (isErrorAuthorizeApp) {
      toast.error(toastMessages.authorize.error);
    }

    if (isSuccessDeleteAuthorizedApp) {
      toast.success(toastMessages.delete.success);
      setOpenSideBar(false);
      reloadTable();
    } else if (isErrorDeleteAuthorizedApp) {
      toast.error(toastMessages.delete.error);
    }
  }, [
    isSuccessAuthorizeApp,
    isErrorAuthorizeApp,
    isSuccessDeleteAuthorizedApp,
    isErrorDeleteAuthorizedApp
  ]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.users.manageAuthorizedApps}
        </StyledTitleSideBar>
        {currentAuthorizedApps.map((app) => (
          <SideBarSwitchWithLabel
            key={app.id}
            label={app.name}
            checked={app.checked}
            onChange={() => handleChange(app)}
          />
        ))}
      </StyledContainerItems>

      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => setOpenSideBar(false)}
        >
          {Strings.common.cancel}
        </button>
        {userMadeChanges && (
          <button
            type="button"
            className="btn-save"
            disabled={!userMadeChanges}
            onClick={handleSave}
          >
            {Strings.common.save}
          </button>
        )}
      </StyledContainerFooterSideBar>
    </>
  );
};
